<template>
  <div>
    <v-data-table :items="items" :headers="headers" items-per-page="-1">
      <template v-slot:item="{ item, headers }" v-if="this.$model.isDir">
        <tr>
          <template v-for="(header, idx) in headers">
            <td
              :key="idx"
              v-if="
                header.key == editedCell.column &&
                item.organizationName === editedCell.item.organizationName
              "
            >
              <v-text-field
                v-model="item[header.key]"
                :hide-details="true"
                dense
                single-line
                :autofocus="true"
                v-on:keyup.enter="saveItemAndClose()"
              >
              </v-text-field>
            </td>
            <td
              :key="idx+'_'"
              v-else
              @click.stop="editItem(item, header.key)"
              class="pointer"
            >
              <span>{{ item[header.key] }}</span>
            </td>
          </template>
        </tr>
      </template>
      <template v-slot:bottom> </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clients: [],
      items: [],
      year: null,
      editedCell: {
        item: null,
        column: "",
      },
      requestCount: 0,
      headers: [
        {
          title: "Наименование ПОО",
          sortable: true,
          key: "organizationName",
        },
        {
          title:
            "Количество зачисленных в ПОО на программы СПО на 2021-2022 учебный год (бюджет+внебюджет)",
          sortable: true,
          key: "students",
        },
        {
          title: "имеют постоянную регистрацию в Челябинской области",
          sortable: true,
          key: "chel",
        },
      ],
    };
  },
  mounted: function () {
    document.addEventListener("click", this.saveItemAndClose);
  },
  beforeDestroy: function () {
    document.removeEventListener("click", this.saveItemAndClose);
  },
  created() {
    let d = new Date();
    let month = d.getMonth();
    this.year = d.getFullYear();
    if (month >= 1 && month <= 8) {
      this.year--;
    }

    this.headers[1].title =
      "Количество зачисленных в ПОО на программы СПО на " +
      this.year +
      "-" +
      (this.year + 1) +
      " учебный год (бюджет+внебюджет)";
    let data = this.$model.modules.region;
    this.clients = data.clients;
    for (let key in this.clients) {
      let item = {
        organizationName: this.clients[key].name,
        chel: 0,
        students: 0,
        ogrn: this.clients[key].ogrn,
        manual: false,
      };

      if (data.regionItems && data.regionItems[this.clients[key].ogrn]) {
        item.chel = data.regionItems[this.clients[key].ogrn].chel;
        item.students = data.regionItems[this.clients[key].ogrn].students;

        if (data.regionItems[this.clients[key].ogrn].manual) {
          item.manual = true;
        }
      }

      this.items.push(item);

      if (!this.isValidHttpUrl(this.clients[key].url) || item.manual) {
        continue;
      }
      this.requestCount++;
      this.getClientData(key);
    }
  },
  watch: {
    requestCount: function (val) {
      if (val == 0) {
        this.axios.post(
          this.$model.wwwroot +
            "/report/minobr/index.php/region/saveRemoteData",
          new URLSearchParams({ data: JSON.stringify(this.items) }),
          {
            headers: {
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        );
      }
    },
  },
  methods: {
    saveItemAndClose() {
      if (this.editedCell.item != null) {
        this.saveItem();
        this.editedCell.item = null;
        this.editedCell.column = "";
      }
    },
    saveItem() {
      this.axios.post(
        this.$model.wwwroot + "/report/minobr/index.php/region/saveManual",
        new URLSearchParams({ data: JSON.stringify(this.editedCell.item) }),
        {
          headers: {
            "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
        }
      );
    },
    editItem(item, colName) {
      this.editedCell.item = item;
      this.editedCell.column = colName;
    },
    getClientData(key) {
      this.axios
        .post(
          this.clients[key].url + "/report/minobr/index.php/region/getData",
          new URLSearchParams({
            username: this.clients[key].username,
            password: this.clients[key].password,
            year: this.year,
            rawurl: true,
          }),
          {
            auth: {
              username: this.clients[key].username,
              password: this.clients[key].password,
            },
            headers: {
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        )
        .then((resp) => {
          this.items.forEach((element) => {
            if (element.organizationName == this.clients[key].name) {
              element.chel = resp.data.chel ?? 0;
              element.students = resp.data.students ?? 0;
            }
          });
          this.requestCount--;
        })
        .catch((reject) => {
          this.axios
            .post(
              this.$model.wwwroot +
                "/blocks/manage_groups/remote/routers/router.php?action=getDocumentData",
              new URLSearchParams({
                script: "/report/minobr/index.php/region/getData",
                clientUrl: this.clients[key].url,
                username: this.clients[key].username,
                password: this.clients[key].password,
                year: this.year,
                rawurl: true,
              }),
              {
                headers: {
                  "Content-type":
                    "application/x-www-form-urlencoded; charset=UTF-8",
                },
              }
            )
            .then((resp) => {
              this.clients[key].status = "ok";
              this.items.forEach((element) => {
                if (element.organizationName == this.clients[key].name) {
                  element.chel = resp.data.chel ?? 0;
                  element.students = resp.data.students ?? 0;
                }
              });
              this.requestCount--;
            })
            .catch((reject) => {
              this.clients[key].status = "fail";
              this.requestCount--;
              this.items.forEach((element) => {
                if (element.organizationName == this.clients[key].name) {
                  element.chel = 0;
                  element.students = 0;
                }
              });
            });
        });
    },
    isValidHttpUrl(string) {
      let url;

      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }

      return url.protocol === "http:" || url.protocol === "https:";
    },
  },
};
</script>
